import { useEffect, useRef, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import React from "react";

// import { pdfjs } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc =
  "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js";


const PdfFirstPageThumbnail = React.memo(function PdfFirstPageThumbnail({ pdfUrl }) {
  const canvasRef = useRef(null);
  const [imgSrc, setImgSrc] = useState(null);

  useEffect(() => {
    if (!canvasRef.current) return;
    const canvas = canvasRef.current;
    setImgSrc(canvas.toDataURL("image/png"));
  }, []);

  return (
    <>
      {!imgSrc && (
        <Document file={{ url: pdfUrl, withCredentials: false }}>
          <Page
            pageNumber={1}
            width={260}
            canvasRef={canvasRef}
            renderTextLayer={false}
            renderAnnotationLayer={false}
          />
        </Document>
      )}

      {imgSrc && (
        <img
          src={imgSrc}
          alt="Catalog thumbnail"
          className="w-full h-full object-cover mx-auto"
        />
      )}
    </>
  );
})
export default PdfFirstPageThumbnail;